module.exports = "/_next/static/images/7ee8d293b94f043f3fa3511f14679d25-mastercard.jpg.webp";